import type { GlobalPrimitiveFieldId } from '#layers/data-model/types/schema/ids';
import { BuiltinBlockIds } from '#layers/data-model/constants/builtin-block-ids';
import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';

export interface SlugFieldOptions {
	sourceField?: GlobalPrimitiveFieldId | null;
}

export default defineFieldTypeTemplate<SlugFieldOptions>({
	type: 'primitive',
	id: 'slug',
	name: '$t:field_types.slug.name',
	description: '$t:field_types.slug.description',
	icon: 'lucide:curly-braces',
	sort: 1200,
	keywords: ['url', 'permalink', 'path'],
	supportedPrimitiveTypes: ['string'],
	options: ({ form, context: { collectionId } }) => form([
		{
			name: 'sourceField',
			label: '$t:field_types.slug.options.source_field.label',
			description: '$t:field_types.slug.options.source_field.description',
			block: BuiltinBlockIds.SystemCollectionFieldSelect,
			props: {
				collectionId,
				includeRelationFields: false,
			},
		},
	]),
});
